import FaqsPageSuccess from './FaqsPageSuccess';

export default FaqsPageSuccess;
